import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { href: "#about", label: "À propos" },
  { href: "#services", label: "Services" },
  { href: "#tarifs", label: "Tarifs" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b transition-all ${
        scrolled ? "border-black/10 shadow-sm" : "border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_mindset-pro-2/artifacts/sp6dkiw7_Logo-PerfbyMind.png"
            alt="Performance by Mind"
            className="h-12 w-12 rounded-xl object-cover ring-1 ring-black/5"
          />
          <span className="font-display text-base md:text-lg font-black tracking-tight text-zinc-900 hidden sm:inline">
            Performance by Mind
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.href.slice(1)}`}
              className="text-base font-medium text-zinc-700 hover:text-[#9B8FE0] transition-colors"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-rdv"
            className="bg-[#9B8FE0] hover:bg-[#8678D4] text-white text-base font-bold px-6 py-3 rounded-full transition-all hover:-translate-y-0.5 hover:shadow-lg"
          >
            Prendre RDV
          </a>
        </nav>

        <button
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-full border border-zinc-200"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${item.href.slice(1)}`}
                className="text-base font-medium text-zinc-800"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-cta"
              className="bg-[#9B8FE0] text-white text-center font-bold px-6 py-3 rounded-full"
            >
              Prendre RDV
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
